module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_mobile_4-2678644522948648b02aa04b257009fe.png";